// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Tooltip_tooltipIcon__2wQ-9{margin-left:5px}", "",{"version":3,"sources":["webpack://./../../libs/console/legacy-ce/src/lib/components/Common/Tooltip/Tooltip.module.scss"],"names":[],"mappings":"AAAA,4BACE,eAAA","sourcesContent":[".tooltipIcon {\n  margin-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltipIcon": "Tooltip_tooltipIcon__2wQ-9"
};
export default ___CSS_LOADER_EXPORT___;
